export const IntercomLauncherClass = 'sgIntercomLauncher'

export default { IntercomLauncherClass }
